import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/spsummoning';

/** 状況 `spsummoning_link`（組み立ては `../fx/spsummoning.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'spsummoning_link', role: 'effect', ...spec }, 'spsummoning_link_effect.js');
